import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { CartOfferLine } from '~shared/modules/shopping-cart-store';

export class CartUpdateApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.CartUpdate;

  constructor(
    private offerLines: CartOfferLine[],
    private recommendation: boolean) {
  }

  getPayload(): any {
    return {
      offerLines: this.offerLines,
      recommendation: this.recommendation,
    };
  }
}
